<template>
	<div class="width_100">
		<naviBack type='list1' title="创建预约单" background="#ffffff" />
		<div v-if="goods_info" class="cmbc_createorder width_100 bg_FFFFFF">
			<div class="cmbc_createorder1 width_100 color_333333 font_size_40 font_weight_600">{{goods_info.serviceName}}</div>
			<div class="cmbc_createorder2 width_100 font_size_30">{{goods_info.venueInfo.venueName}}</div>
		</div>
		<div class="cmbc_co_body width_100 border_radius_16">
			<div v-if="goods_info" class="cmbc_co_body_item width_100 bg_FFFFFF border_radius_16">
				<div class="cmbc_co_body_item_title width_100 font_size_30 color_333333 font_weight_600">预约信息</div>
				<div class="cmbc_co_body_item_block width_100 display_between_center font_size_28 color_666666">
					预约时间
					<div class="color_333333" style="background-image: none;">{{date_obj?date_obj.date_nor:''}}　{{time}}
					</div>
				</div>
				<div
					class="cmbc_co_body_item_block width_100 display_between_center font_size_28 color_666666 text_ellipsis2">
					预约人
					<input v-model="user_info.name" class="color_333333" type="text" maxlength="48"
						placeholder="请输入预约人姓名" />
				</div>
				<div
					class="cmbc_co_body_item_block width_100 display_between_center font_size_28 color_666666 text_ellipsis2">
					手机号
					<input v-model="user_info.phone" class="color_333333" type="tel" maxlength="11"
						placeholder="请输入信用卡预留手机号" />
				</div>
			</div>

			<div v-if="false" :class="[{'cmbc_co_body_guest_no':guest_arr.length>0},'cmbc_co_body_guest']">
				<div @click="addGuest()" class="cmbc_co_body_guest_head">
					添加同行人
					<img src="../resource/add.png" />

				</div>
				<div :class="[{'cmbc_co_body_guest_cont':guest_arr.length>0}]">
					<div v-for="(ga_item,ga_index) in guest_arr" :key="'ga_item'+ga_index"
						class="cmbc_co_body_guest_cont_item">
						<input v-model="guest_arr[ga_index]" maxlength="48" type="text" placeholder="请输入同行人" />
						<div @click="deleteGuest(ga_index)" class="cmbc_co_body_guest_cont_item_icon">
							<img src="../resource/delete.png" />
						</div>
					</div>
				</div>
			</div>

			<div v-if="goods_info" class="cmbc_co_body_tips width_100 color_666666 bg_FFFFFF border_radius_16">
				<div v-if="goods_info.bookingInstructions" class="cmbc_co_body_tips_title font_size_30 font_weight_600 color_333333">预约须知：</div>
				<div v-if="goods_info.bookingInstructions" class="font_size_26" v-html="goods_info.bookingInstructions"></div>

				<div v-if="goods_info.cancellationPolicy" class="cmbc_co_body_tips_title font_size_30 font_weight_600 color_333333">退订规则：</div>
				<div v-if="goods_info.cancellationPolicy" class="font_size_26" v-html="goods_info.cancellationPolicy"></div>

				<div v-if="goods_info.tips" class="cmbc_co_body_tips_title font_size_30 font_weight_600 color_333333">温馨提示：</div>
				<div v-if="goods_info.tips" class="font_size_26" v-html="goods_info.tips"></div>
			</div>
		</div>

		<div class="cmbc_co_bottom width_100 bg_FFFFFF">
			<div @click="confirmOrderBefore()" class="width_100 display_center_center color_ffffff font_size_32">提交订单
			</div>
		</div>

	</div>
</template>

<script>
	import {
		datePrintStr,
		isPhone
	} from "../lib/utils"
	import naviBack from '../components/navi_back.vue';
	import {
		getVenueServiceDetail,
		createOrder
	} from '../api/api.js'
	export default {
		components: {
			naviBack
		},
		name: "",
		data() {
			return {
				user_info: {
					name: '',
					phone: ''
				},
				max_guest: 0,
				guest_arr: [],

				date: '', //预约日期
				date_obj: null, //预约日期
				time: '', //预约时间
				service_id: '', //商品id

				goods_info: null,
			};
		},
		mounted() {
			this.$RCLoading.show();
			// console.log(this.$route,datePrintStr(this.$route.params.date));
			this.date = this.$route.params.date
			this.date_obj = datePrintStr(this.$route.params.date)
			this.time = this.$route.params.time
			this.service_id = this.$route.params.service_id
			this.max_guest = this.$route.params.max_num > 4 ? 4 : this.$route.params.max_num
			this.getGoodsDetail()
		},
		methods: {
			async getGoodsDetail() {
				var $this = this
				var params = {
					serviceId: this.$route.params.service_id
				}
				try {
					var res = await getVenueServiceDetail(params)
					console.log(res);
					if(res.data.noticeContent){
						$this.$dialog.alert({
						  title: '温馨提示',
						  message: res.data.noticeContent,
						  messageAlign:'left',
						  confirmButtonColor:'#F77F28'
						}).then(() => {
						  // on close
						});
					}
					$this.goods_info = res.data
					$this.$RCLoading.hide();
				} catch (error) {
					$this.$RCLoading.hide();
					//TODO handle the exception
				}
			},
			addGuest() {
				if (this.max_guest == 0) {
					this.$toast({
						message: '不可携带嘉宾',
						forbidClick: true,
					});

					return
				}
				if (this.guest_arr.length == this.max_guest) {
					this.$toast({
						message: '最多可携带' + this.max_guest + '名嘉宾',
						forbidClick: true,
					});
					return
				}
				this.guest_arr = [...this.guest_arr, ...['']]
			},
			deleteGuest(e) {
				var guest_arr = this.guest_arr
				guest_arr.splice(e, 1)
				this.guest_arr = guest_arr
			},
			// 提交
			confirmOrderBefore() {
				var $this = this
				if (!this.user_info.name) {
					this.$toast('请输入预约人姓名')
					return
				}
				if (!isPhone(this.user_info.phone)) {
					this.$toast('请输入预约手机号')
					return
				}
				if (this.guest_arr.length > 0 && (this.guest_arr).includes('')) {
					this.$toast('请输入同行人姓名')
					return
				}
				this.$dialog.confirm({
						title: '温馨提示',
						message: '请确认预约手机号：'+this.user_info.phone+' 与持卡人银行预留手机号一致',
						confirmButtonText:'确认',
						confirmButtonColor:'#F77F28',
						cancelButtonText:'修改',
						cancelButtonColor:'#666666'
					})
					.then(() => {
						// on confirm
						$this.$RCLoading.show();
						$this.confirmOrder()
					})
					.catch(() => {
						// on cancel
					});
			},
			async confirmOrder() {
				var $this = this
				console.log(this.user_info);
				console.log(this.guest_arr);
				console.log(this.date);
				console.log(this.time);
				console.log(this.goods_info);
				
				
				var params = {
					serviceId: this.goods_info.serviceId,
					bookDate: this.date,
					bookTime: this.time,
					bookName: this.user_info.name,
					bookMobile: this.user_info.phone,
				}
				try {
					var res = await createOrder(params)
					console.log(res);
					sessionStorage.setItem('order_confirm', JSON.stringify(res.data))
					sessionStorage.setItem('goods_info', JSON.stringify($this.goods_info))
					setTimeout(() => {
						$this.$RCLoading.hide();
						$this.$router.push({
							name: 'cmbc_cr_order_comfirm'
						})
					}, 100)
				} catch (error) {
					$this.$RCLoading.hide();
					//TODO handle the exception
				}
			}
		},
	};
</script>

<style lang="less" scoped="scoped">
	@vm_base: 1/750 * 100vw;

	.cmbc_createorder {
		padding: 40*@vm_base 40*@vm_base 60*@vm_base 40*@vm_base;

		.cmbc_createorder1 {
			line-height: 1.3;
		}

		.cmbc_createorder2 {
			color: #F77F28;
			line-height: 1.3;
			margin-top: 12*@vm_base;
		}
	}

	.cmbc_co_body {
		background: #F6F7F9;
		position: relative;
		margin-top: -20*@vm_base;
		padding: 20*@vm_base;
		padding-bottom: calc(constant(safe-area-inset-bottom) / 2 + 160*@vm_base);
		padding-bottom: calc(env(safe-area-inset-bottom) / 2 + 160*@vm_base);

		.cmbc_co_body_item {
			padding: 30*@vm_base 30*@vm_base 20*@vm_base 30*@vm_base;

			.cmbc_co_body_item_title {
				padding-bottom: 10*@vm_base;
				line-height: calc(4 / 3);
			}

			.cmbc_co_body_item_block {
				margin-top: 6*@vm_base;

				div {
					line-height: calc(48 / 28);
					// background-image: url(../resource/more_F77F28.png);
					background-repeat: no-repeat;
					background-position: right center;
					background-size: 30*@vm_base;
					// padding-right: 32*@vm_base;
				}

				input {
					max-width: 80%;
					min-width: 50%;
					height: 48*@vm_base;
					text-align: right;
					border: none;
					// background-image: url(../resource/more_F77F28.png);
					background-repeat: no-repeat;
					background-position: right center;
					background-size: 30*@vm_base;

					// padding-right: 32*@vm_base;
					&::placeholder {
						color: #999999;
					}
				}
			}
		}

		.cmbc_co_body_tips {
			padding: 10*@vm_base 30*@vm_base 30*@vm_base 30*@vm_base;
			margin-top: 20*@vm_base;
			div {
				line-height: calc(39 / 26);
				white-space: pre-line;
			}

			.cmbc_co_body_tips_title {
				margin-top: 20*@vm_base;
			}
		}



		.cmbc_co_body_guest {
			background: #FFFFFF;
			border-radius: 16*@vm_base;
			padding: 30*@vm_base 20*@vm_base;
			margin-top: 20*@vm_base;

			.cmbc_co_body_guest_head {
				width: 100%;
				display: flex;
				justify-content: center;
				align-items: center;
				font-size: 28*@vm_base;
				color: #333333;
			}

			.cmbc_co_body_guest_head img {
				width: 28*@vm_base;
				height: 28*@vm_base;
				margin-left: 10*@vm_base;
			}

			.cmbc_co_body_guest_cont {
				margin-top: 20*@vm_base;
				border-top: 1*@vm_base solid #d9d9d9
			}

			.cmbc_co_body_guest_cont_item {
				width: 100%;
				white-space: nowrap;
				display: flex;
				justify-content: space-between;
				align-items: center;
				font-size: 28*@vm_base;
				color: #666666;
				/* border-bottom: 1*@vm_base solid #d9d9d9; */
			}

			.cmbc_co_body_guest_cont_item_icon {
				width: 64*@vm_base;
				height: 92*@vm_base;
				display: flex;
				justify-content: center;
				align-items: center;
			}

			.cmbc_co_body_guest_cont_item_icon img {
				width: 32*@vm_base;
				height: 32*@vm_base;
			}

			.cmbc_co_body_guest_cont_item input {
				width: 100%;
				text-align: left;
				height: 92*@vm_base;
				border: none;
			}
		}

		.cmbc_co_body_guest_no {
			padding-bottom: 0;
		}



	}

	.cmbc_co_bottom {
		position: fixed;
		bottom: 0;
		left: 0;
		padding: 25*@vm_base 75*@vm_base;
		padding-bottom: calc(constant(safe-area-inset-bottom) / 2 + 25*@vm_base);
		padding-bottom: calc(env(safe-area-inset-bottom) / 2 + 25*@vm_base);
		box-shadow: -4*@vm_base -4*@vm_base 6*@vm_base rgba(243, 207, 166, 0.5);
		border-radius: 16*@vm_base 16*@vm_base 0 0;

		div {
			height: 80*@vm_base;
			background: linear-gradient(233deg, #FB8027 0%, #FFA663 100%);
			border-radius: 40*@vm_base;
		}
	}
</style>


// WEBPACK FOOTER //
// src/views/create_order_1.vue